<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{ title }}
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" mat-dialog-close>
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div class="nova__dialog__content flex-col" mat-dialog-content>
    <div class="search-panel space-between" [class.search-panel__active]="isLoading || isSucceed">
        <div class="search-bar flex-row">
            <input class="search-bar__input"
                   [formControl]="searchText"
                   type="search"
                   (keyup.enter)="searchCandidates(searchText.value)"
                   placeholder="Candidate Name, Email, or Phone"
                   data-cy="searchCandidatesSearchText" />
            <button mat-flat-button class="search-bar__button" color="primary" (click)="searchCandidates(searchText.value)">
                <mat-icon>search</mat-icon>
            </button>
        </div>
        <div class="button-toolbar" *ngIf="!hasNoResults">
            <div class="nova-grid__column-menu">
                <a class="toolbar-button__small" mat-raised-button routerLink="/recruiting/search-all-candidates" target="_blank">
                    ADVANCED SEARCH
                </a>
                <a class="toolbar-button__small" mat-raised-button routerLink="/recruiting/candidates/add" target="_blank" data-cy="addCandidateButton">
                    ADD CANDIDATE
                </a>
            </div>
        </div>
    </div>
    <div class="search-results">
        <div class="search-results__content" *ngIf="isInitial">
            <img src="/assets/images/svg/start_a_search.svg" alt="start_a_search.svg">
            <p class="search-results__text">Use the search bar to find a candidate.</p>
        </div>
        <div class="search-results__content" *ngIf="hasNoResults">
            <img src="/assets/images/svg/undraw_feeling_blue_4b7q.svg" alt="undraw_feeling_blue_4b7q.svg">
            <p class="search-results__text">
                We couldn't find any candidate profiles that match your search. What would you like to do?
            </p>
            <div class="space-between">
                <a class="toolbar-button" color="primary" mat-raised-button routerLink="/recruiting/search-all-candidates" target="_blank">
                    ADVANCED SEARCH
                </a>
                <a class="toolbar-button" color="primary" mat-raised-button routerLink="/recruiting/candidates/add" target="_blank" data-cy="addCandidateButton">
                    ADD CANDIDATE
                </a>
            </div>
        </div>
        <div class="search-results__grid" [class.hidden]="!isSucceed && !isLoading">
            <nova-candidate-search-grid></nova-candidate-search-grid>
        </div>
    </div>
</div>
